import * as SynthesisReviewType from './synthesisReviewType'
import useSyntheticReview from './useSyntheticReview'
import MyAccordion from '../../../../../control/accordion/accordion'
import RichTextEditor from '../../../../../control/richTextEditor/richTextEditor'
import { Grid, makeStyles } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import TreeCheckbox from '../../../../../control/treeCheckbox/treeCheckbox'
import useTranslate from '../../../../../i18n/useTranslate'
import PageAction from '../pageAction'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import Dialog from '../../../../../control/dialog/dialog'
import { approveStatusREC1, approveStatusREC2 } from '../../../../../constants/approveStatus'
import DisplayUpdater from '../../../shareUI/displayUpdater/displayUpdater'
import ModeAccordion from '../../../shareUI/modeAccordion/ModeAccordion'

const SynthesisReviewREC1View: React.FC<SynthesisReviewType.SynthesisReviewViewType> = (props) => {
    const {
        isViewMode,
        projectData,
        configDialog,
        initialValues,
        initialComment,
        initialCommentRichTextEditor,
        isShowUpdateDate,
        initialRichRemark,
        documentInfoList,
        initialRichTextEditor,
        isHideDocumentCertificate = false,
        isFlowApproveWithComment = false,
        onRefDialog,
        onSubmitForm,
        onClickCancel,
        handleDirtyChange,
        isEditStampFile,
        clickEditStampFile,
        cancelEditStampFile,
        saveEditStampFile,
    } = props

    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()

    const isShowComment = true
    const isSynthesisApprove: boolean =
        projectData?.synthesisApproveStatusInfo?.value === approveStatusREC1.approveForContiueResearch ||
        projectData?.synthesisApproveStatusInfo?.value === approveStatusREC2.approveForContiueResearch //ผลการพิจารณาเป็น อนุมัติให้ดำเนินการวิจัยต่อเนื่อง
    const isDisplayTreeCheckboxSection: boolean =
        !isHideDocumentCertificate && (isFlowApproveWithComment || isSynthesisApprove)

    const renderOfficerView = (name: string, index: number) => {
        return (
            <>
                <Grid item xs={12} md={12} lg={12}>
                    <RichTextEditor
                        name={`${name}.commentList`}
                        initialRichTextEditor={initialCommentRichTextEditor[index]}
                        disabled={true}
                        label={
                            initialComment[index].no
                                ? `${initialComment[index].no}. ${initialComment[index].topic}`
                                : translate.get('LABEL.SUGGESTION_NOTICE')
                        }
                        isHideToolbar={true}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <RichTextEditor
                        name={`${name}.consideration`}
                        initialRichTextEditor={initialRichTextEditor[index]}
                        disabled={isViewMode}
                        isHideToolbar={isViewMode}
                        label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                        required
                    />
                </Grid>
            </>
        )
    }

    const renderViewComponent = (language: string) => {
        return (
            <TreeCheckbox
                disabled={!isEditStampFile}
                name={'documentCertificate'}
                dataSource={documentInfoList}
                labelRadioEN={translate.get('LABEL.ENG')}
                labelRadioTH={translate.get('LABEL.THAI')}
                isLangTH={translate.languageStore.currentLanguage === translate.languageKey.th}
            />
        )
    }

    const renderEditComponent = (language: string) => {
        return (
            <TreeCheckbox
                disabled={!isEditStampFile}
                name={'documentCertificate'}
                dataSource={documentInfoList}
                labelRadioEN={translate.get('LABEL.ENG')}
                labelRadioTH={translate.get('LABEL.THAI')}
                isLangTH={translate.languageStore.currentLanguage === translate.languageKey.th}
            />
        )
    }

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues, commentDirector: initialComment }}
            keepDirtyOnReinitialize={true}
            mutators={{
                ...arrayMutators,
            }}
        >
            {(props) => {
                const { form, handleSubmit, dirty, invalid, errors } = props

                return (
                    <>
                        <Grid container spacing={2}>
                            {!isFlowApproveWithComment && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.RESOLUTION')}>
                                        <Grid container item justify="flex-start" spacing={2}>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <Grid item xs={12} md={12} lg={12}>
                                                    <RichTextEditor
                                                        name="remark"
                                                        initialRichTextEditor={initialRichRemark}
                                                        disabled={isViewMode}
                                                        isHideToolbar={isViewMode}
                                                        // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                        maxLength={2000}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )}
                            {!isFlowApproveWithComment && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.NOTIFY_REVIEW_OUTCOME')}>
                                        <Grid container item justify="flex-start" spacing={2}>
                                            {isShowComment && (
                                                <FieldArray name="commentDirector">
                                                    {({ fields }) => {
                                                        return fields?.map((name, index) =>
                                                            renderOfficerView(name, index),
                                                        )
                                                    }}
                                                </FieldArray>
                                            )}
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )}
                            {isDisplayTreeCheckboxSection && (
                                <Grid item xs={12}>
                                    <ModeAccordion
                                        title={translate.get('LABEL.DOC_TO_BE_CERTIFIED')}
                                        renderViewComponent={() => renderViewComponent('TH')}
                                        renderEditComponent={() => renderEditComponent('TH')}
                                        isViewMode={isViewMode}
                                        onClickEdit={() => clickEditStampFile()}
                                        onCancel={() => cancelEditStampFile()}
                                        onConfirm={() => saveEditStampFile()}
                                    ></ModeAccordion>
                                </Grid>
                            )}

                            {isShowUpdateDate && <DisplayUpdater />}
                            {!isViewMode && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <PageAction
                                        onClickClose={() => {
                                            onClickCancel(dirty)
                                        }}
                                        onClickSave={() => {
                                            form.change('submitType', 'save')
                                            handleSubmit()
                                            invalid &&
                                                errors &&
                                                snackbarAction.openSnackbar({
                                                    message: translate.get('MESSAGE.M012'),
                                                    type: 'error',
                                                })
                                        }}
                                        onClickSaveDraft={() => {
                                            form.change('submitType', 'draft')
                                            handleSubmit()
                                        }}
                                    />
                                </Grid>
                            )}
                        </Grid>

                        <Dialog onRef={onRefDialog} {...configDialog} />
                        <FormSpy
                            subscription={{ dirty: true, values: true }}
                            onChange={(formState) => {
                                handleDirtyChange(formState, form)
                            }}
                        />
                    </>
                )
            }}
        </Form>
    )
}

const SynthesisReviewREC1: React.FC<SynthesisReviewType.SynthesisReviewType> = (props) => {
    const useSyntheticReviewModel = useSyntheticReview(props)
    return <SynthesisReviewREC1View {...useSyntheticReviewModel} {...props} />
}
const useStyles = makeStyles((theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
    paper: {
        width: '100%',
        height: 128,
        padding: 20,
    },
    titleFont: {
        color: '#BDBDBD',
    },
    contentFont: {
        fontWeight: 'bold',
    },
}))

export default SynthesisReviewREC1
